/*=========================================================================================
  File Name: module-supplier-actions.js
  Description: Supplier Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import UserSetupAPI from '@/api/UserSetupAPI.js';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';
import { NumberRetry, NumberTimeOutRetry } from '@/api/base/base-api';

export default {
	getConfigUserSetup: async function(context, payload) {
		let res = await httpClient.getAsync({ url: UserSetupAPI.getAPIUrlSubParam(commonFunc.getSubParam()) });
		if (res && res.Data && res.Success) {
			//Cập nhật lại
			context.commit('updateUserSetup', { ...res.Data });
		}
		return res;
	},

	saveUserSetup: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: UserSetupAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/save`,
			data: payload
		});

		if (res && res.Data && res.Success) {
			//Cập nhật lại
			context.commit('updateUserSetup', { ...res.Data });
		}
		return res;
	}
};
